import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Type-safe selector hook for UI only
export const useUI = () => useAppSelector(state => state.ui);

// Hook for chart bar config
export const useChartBarConfig = () => useAppSelector(state => state.ui.chartBarConfig);
export { initialState as initialUIState } from './slices/uiSlice';